import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Profile() {
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem('token');

        if (!token) {
          setError('User not authenticated');
          setLoading(false);
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/profile`, // updated to use env variable
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setUserProfile(response.data);
        setLoading(false);

      } catch (err) {
        console.error('Error fetching user profile:', err);
        setError(err.response?.data?.error || 'Error fetching user profile');
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  if (loading) {
    return <div>Loading profile...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!userProfile) {
    return <div>No profile data available.</div>;
  }

  return (
    <>
    <div className="profile-container">
      <div className="profile-header">
        {/* Profile Picture and Change Avatar Link
        <div className="profile-picture">
          <a href="./profile"><img src="/img/testpfimg.png" width="80px" height="80px" id="avatar" alt="pfp"></img></a>
          <p className="change-avatar"><a href="./profile">change avatar</a></p>
        </div>
        End Profile Picture and Change Avatar Link */}
        <div className="profile-username">
          <h2>{userProfile.username}</h2>
          <p>Profile Stats</p>
        </div>
        <div>
          <div className="profile-stats">

            <p className="profile-items">Wins: <span className="winloss">{userProfile.wins}</span></p>
            <p className="profile-items">Losses: <span className="winloss">{userProfile.losses}</span></p>
            {userProfile.mostRecentScore && (
              <p className="profile-items">
                Most Recent Score Prediction:
                <span className="winloss"> {userProfile.mostRecentScore}</span>
                {userProfile.mostRecentWeek && <span> (Week {userProfile.mostRecentWeek})</span>}
              </p>
            )}
            <a className="submit-button home-cta" href="/">Back to Home</a>
          </div>


        </div>
      </div>
    </div>
    </>
  );
}

export default Profile;